import { useEffect, useRef } from "react";
import Greetings from "./Greetings";


const Body = () => {
    const bodyRef = useRef(null);

    const scrollToBottom = () => {
        if (bodyRef.current) {
            bodyRef.current.scrollTop = bodyRef.current.scrollHeight;
        }
    };

    useEffect(() => {
        // Observe changes in the body-tag container
        const observer = new MutationObserver(() => {
            scrollToBottom();
        });

        if (bodyRef.current) {
            observer.observe(bodyRef.current, {
                childList: true,
                subtree: true, // Watches nested components
            });
        }

        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        scrollToBottom(); // Initial scroll to bottom
    }, []);

    return (
        <div className="body-tag" ref={bodyRef}>
            <Greetings />
        </div>
    );
};

export default Body;
